"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Continue = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _types = require("../../types");
var _utils = require("../../utils");
var _FormattedMessage = require("../FormattedMessage");
var _LoadingScreen = require("../LoadingScreen");
var _styles = require("./styles");
var _useContinue = require("./useContinue");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorMessageHolder = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.grey[400]
}));
const Continue = ({
  continueButtonTooltip,
  isAnonymous,
  isOnlinePaymentMethod,
  isOrderReviewSkipped,
  selectedStep,
  setCurrentStep,
  setIsRegistrationVisible
}) => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    errorCode,
    dialogMessage,
    handleClose,
    isFallbackRunning,
    onContinueClick,
    onFinaliseOrderClick,
    onRegisterClick,
    orderState
  } = (0, _useContinue.useContinue)({
    isOnlinePaymentMethod,
    isOrderReviewSkipped,
    selectedStep,
    setIsRegistrationVisible,
    setCurrentStep
  });
  const onLoginClick = (0, _react.useCallback)(() => {
    (0, _utils.openLogin)();
    // analytics
    (0, _utils.dispatchUserActionEvent)([_types.MetaHierarchy.Login]);
  }, []);
  if (isAnonymous) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        ...getTestIdProps(_types.TestId.LoginButton),
        variant: "contained",
        color: "primary",
        sx: {
          marginTop: 3
        },
        onClick: onLoginClick,
        children: formatMessage('logIn')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        ...getTestIdProps(_types.TestId.RegisterButton),
        variant: "outlined",
        color: "default",
        sx: {
          marginTop: 3
        },
        onClick: onRegisterClick,
        children: formatMessage('registerToContinue')
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingScreen.LoadingScreen, {
      isFallbackRunning: isFallbackRunning,
      shouldShowLoadingScreen: orderState === _types.OrderState.Pending
    }), dialogMessage === undefined ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackDialog, {
      hideCloseButton: true,
      disablePortal: false,
      open: Boolean(dialogMessage),
      severity: errorCode ? 'error' : 'info',
      onClose: handleClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [errorCode ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h4",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "unableToContinue"
          })
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ErrorMessage, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: dialogMessage
          })
        }), errorCode ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(ErrorMessageHolder, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
              id: "errorCode"
            }), ": ", errorCode]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
            fullWidth: true,
            variant: "contained",
            color: "primary",
            sx: {
              marginTop: 6
            },
            onClick: handleClose,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
              id: "ok"
            })
          })]
        }) : null]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
      title: continueButtonTooltip ?? '',
      placement: "bottom",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: selectedStep === _types.ShoppingStep.Checkout ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          fullWidth: true,
          ...getTestIdProps(_types.TestId.FinaliseOrderButton),
          variant: "contained",
          color: "primary",
          disabled: continueButtonTooltip !== undefined,
          sx: {
            marginTop: 3
          },
          onClick: onFinaliseOrderClick,
          children: formatMessage('finaliseOrder')
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          fullWidth: true,
          ...getTestIdProps(_types.TestId.ContinueButton),
          variant: "contained",
          color: "primary",
          disabled: continueButtonTooltip !== undefined,
          sx: {
            marginTop: 3
          },
          onClick: onContinueClick,
          children: formatMessage('continue')
        })
      })
    })]
  });
};
exports.Continue = Continue;